import React from "react";
import Cookies from "universal-cookie";
import Button from "@mui/material/Button"
import '../../../App.css';
import { NavLink } from "react-router-dom";
import * as RiIcons from 'react-icons/ri';
import * as BsIcons from 'react-icons/bs'
import AlertsModal from '../Components/AlertsModal'


const cookies = new Cookies();
const DoctorDashboard = ()=> {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
        const removeCookie = () => {
            cookies.remove("token")
            cookies.remove("user-type")
            window.location.href = "/"
        }

        if (cookies.get("token") && cookies.get("user-type") && cookies.get("user-type") === '1') {
            return (
                <>
                <AlertsModal color={"#2E5266"} open={open} handleOpen={handleOpen} handleClose={handleClose} />
                <div className="Doctor-dashboard-div" style={{color:'#2E5266FF'}}>
                    <div className="Doctor-dashboard-heading">
                        <div style={{fontSize:56}}>مرحباً بكَ د. حسن احمد</div>
                        <h4 >يمكنك اختيار النافذة المناسبة لغايتك من الخيارات ادناه ..</h4>
                        <Button onClick={()=>{
                            setOpen(true)
                        }} sx={{color:"#148F0C",fontFamily:"'Tajawal', sans-serif"}} variant="text">لديك اشعارات جديدة .. اضغط هنا للمتابعة</Button>
                    </div>
                    <div className="Doctor-dashboard-options" >

                        {/* PAYMENT GATEWAY */}
                        <NavLink className="Doctor-dashboard-option-card" to='/secure-payment' style={{color:'#2E5266FF'}}>
                        <div style={{ width: '20%' }}>
                                <RiIcons.RiArrowDropLeftLine size={100} />
                            </div>
                            
                            <div style={{ width: '70%', textAlign: 'right' }}>
                                <h2>نافذة الدفع الآمن</h2>
                                <h6>.يمكنك من هذه النافذة دفع الغرامات والمستحقات المترتبة من قبل نقابة الاطباء</h6>
                            </div>
                            <div style={{ width: '20%', textAlign: 'center' }}>
                                <RiIcons.RiSecurePaymentLine size={120} />
                            </div>
                        </NavLink>

                        {/* TAX VIEW */}
                        <NavLink className="Doctor-dashboard-option-card" to='/pending-and-history-payment' style={{color:'#2E5266FF'}}>
                        <div style={{ width: '20%' }}>
                                <RiIcons.RiArrowDropLeftLine size={100} />
                            </div>
                            
                            <div style={{ width: '70%', textAlign: 'right' }}>
                                <h2>نافذة متابعة الضرائب المسجلة</h2>
                                <h6>.يمكنك من هذه النافذة مراقبة ومتابعة جميع الضرائب المسددة والمستحقة عليك</h6>
                            </div>
                            <div style={{ width: '20%', textAlign: 'center' }}>
                                <BsIcons.BsCardChecklist size={100} />
                            </div>
                        </NavLink>
                    </div>
                    <div onClick={()=>removeCookie()} className="Doctor-dashboard-footer">
                        <div style={{fontSize:16,    textAlign: 'end'}}>تسجيل الخروج</div>
                    </div>
                </div>
                </>
            );
        } else {
            window.location.href = "/"
        }
    
}


export default DoctorDashboard;
